<!-- 多选、商品、 选择单据 -->
<template>
  <div>
    <el-dialog
      :title="title"
      :visible.sync="dialogVisible"
      width="60%"
      top="10vh"
    >
      <div class="template-body">
        <div class="template-body-class">
          <div
            v-if="who == 'sheetinfo'"
            class="template-body-class-l-f"
            style=""
          >
            <span
              @click="classChange(item)"
              v-for="item in classList"
              :key="item"
              class="template-body-class-l-f-span"
              :class="
                ckeyWords.includes(item) == true
                  ? 'template-body-class-l-f-clicked'
                  : 'template-body-class-l-f-span'
              "
            >
              {{ item }}
            </span>
          </div>
          <div>
            <el-input
              placeholder="模糊查询内容"
              size="small"
              v-model="search_value"
              @change="searchGoods"
            >
              <template slot="append"
                ><i class="el-icon-search" @click="searchGoods"></i>
              </template>
            </el-input>
          </div>
        </div>
        <div class="template-body-main">
          <!-- <el-scrollbar wrapStyle="overflow-x:hidden;" style="height:100%;float: left;">
            <div v-for="item in 30" :key="item" class="template-body-main-item">
            {{ item }}</div>
          </el-scrollbar> -->
          <ve-table
            v-if="dialogVisible"
            border-x
            border-y
            ref="maintableRef"
            rowKeyFieldName="rowKey"
            :fixed-header="true"
            :columns="columns"
            :table-data="tableData"
            :maxHeight="`53vh`"
            :border-around="true"
            :radio-option="radioOption"
            :cell-style-option="cellStyleOption"
            :checkbox-option="checkboxOption"
            :virtual-scroll-option="virtualScrollOption"
            row-key-field-name="rowKey"
            enable="true"
          />
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="handleClose(false)">取 消</el-button>
        <el-button size="small" type="primary" @click="handleClose(true)"
          >确 定</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>
<script>
import { cellStyleOption } from "@/js/sheettablecolumn";
import { permissionMerchantList } from "@/api/merchant.js";
import {
  selectBoxcolumns,
  selectSheetColumns,
  radioBoxcolumns
} from "@/js/sheettablecolumn.js";
export default {
  name: "wty-selectBox",
  props: ["who"],
  watch: {
    search_value(nv, ov) {
      this.searchGoods();
    }
  },
  data() {
    return {
      title: "",
      checkedList: [],
      search_value: "",
      allGoods_list: [],
      dialogVisible: false,
      classList: ["所有", "已审核", "未审核"],
      ckeyWords: ["未审核"],
      tableData: [],
      mainH: [],
      cellStyleOption: cellStyleOption,
      radioOption: {
        // 行选择改变事件
        selectedRowChange: ({ row }) => {
          this.radiocheckgoods = row;
        }
      },
      radiocheckgoods: {},
      //虚拟滚动
      virtualScrollOption: {
        // 是否开启
        enable: true
      },

      checkboxOption: {
        // 行选择改变事件
        selectedRowChange: ({ row, isSelected, selectedRowKeys }) => {
          this.checkedList = selectedRowKeys;
        },
        // 全选改变事件
        selectedAllChange: ({ isSelected, selectedRowKeys }) => {
          this.checkedList = selectedRowKeys;
        }
      },

      columns: []
    };
  },
  created() {
    if (this.who == "goodsinfo") {
      this.columns = selectBoxcolumns;
    } else if (this.who == "sheetinfo") {
      this.columns = selectSheetColumns;
    } else if (this.who == "goodsinfoRadio") {
      this.columns = radioBoxcolumns;
    }
  },
  mounted() {
    
  },
  methods: {
    searchGoods() {
      //TODO: 搜索的时候  需要加上搜索单据
      if (this.who == "goodsinfo" || this.who == "goodsinfoRadio") {
        if (this.allGoods_list == []) return;
        var that = this;
        // search_value;
        if (this.search_value == "" || this.search_value.length == 0) {
          this.tableData = [];
          this.tableData = this.allGoods_list;
          return;
        } else {
          let list = this.allGoods_list.filter((item, index) => {
            return (
              item.item_name.indexOf(that.search_value) >= 0 ||
              String(item.barcode).indexOf(that.search_value) >= 0
            );
          });
          this.tableData = [];
          this.tableData = list;
        }
      }
    },
    classChange(keywords) {
      this.ckeyWords = [];
      this.ckeyWords.push(keywords);
      this.tableData = [];
      switch (keywords) {
        case "所有":
          this.tableData = this.allGoods_list;
          /*  */
          break;
        case "已审核":
          console.log("已审核");

          for (let i = 0; i < this.allGoods_list.length; i++) {
            if (this.allGoods_list[i].approve_flag == "1") {
              this.tableData.push(this.allGoods_list[i]);
            }
          }
          break;
        case "未审核":
          console.log("未审核");

          for (let i = 0; i < this.allGoods_list.length; i++) {
            if (this.allGoods_list[i].approve_flag == "0") {
              this.tableData.push(this.allGoods_list[i]);
            }
          }
          break;
      }
    },
    searchTemplate() {},
    handleClose(done) {
      if (done) {
        if (this.who == "goodsinfo") {
          if (this.checkedList.length == 0) {
            this.warnMessage("请选择商品");
          } else {
            this.$emit("getReturn", this.setcheckedList());
          }
        } else if (this.who == "sheetinfo") {
          this.$emit("getReturn", this.radiocheckgoods);
        } else if (this.who == "goodsinfoRadio") {
          this.$emit("getReturn", this.radiocheckgoods);
        }
        this.dialogVisible = false;
      } else {
        this.dialogVisible = false;
      }
    },
    setcheckedList() {
      var list = [];
      // for(let i=0;i<this.checkedList.length;i++){}
      for (let j = 0; j < this.allGoods_list.length; j++) {
        if (this.checkedList.indexOf(this.allGoods_list[j].rowKey) >= 0) {
          list.push(this.allGoods_list[j]);
        }
      }
      return list;
    },
    async showDialog(arr, title) {
      const that = this;
      if (title) {
        this.title = title;
      }
      // console.log("所有单据", arr);
      this.tableData = [];
      if (this.who == "goodsinfo") {
        for (let i = 0; i < arr.length; i++) {
          arr[i].rowKey = i;
          this.tableData.push(arr[i]);
         /*  if (i >= 100) {
            this.allGoods_list = this.tableData;
            this.checkedList = [];
            return;
          } */
        }
        this.allGoods_list = this.tableData;
      } else if (this.who == "goodsinfoRadio") {
        // console.log("arr-----------------", arr);
        for (let i = 0; i < arr.length; i++) {
          arr[i].rowKey = i;
          this.tableData.push(arr[i]);
          if (i >= 100) {
            this.allGoods_list = this.tableData;
            this.checkedList = [];
            return;
          }
        }
        this.allGoods_list = this.tableData;
      } else if (this.who == "sheetinfo") {
        const res = await permissionMerchantList();
        // console.log("所有店铺", res);
        var shoplist = res;
        for (let i = 0; i < arr.length; i++) {
          arr[i].mch_name = localStorage.getItem("merchant_name");
          for (let j = 0; j < shoplist.length; j++) {
            if (arr[i].other_mch_no == shoplist[j].merchant_id) {
              arr[i].other_mch_name = shoplist[j].sub_name;
            }
          }
          if (arr[i].approve_flag == "0") {
            arr[i].approve = "未审核";
            arr[i].class_state = "9";
          } else {
            arr[i].approve = "已审核";
            arr[i].class_state = "8";

          }
          arr[i].rowKey = i;
          this.tableData.push(arr[i]);
        }
        console.log(this.tableData);
        this.allGoods_list = this.tableData;
        this.classChange("未审核");
      }

      this.checkedList = [];
      this.radiocheckgoods = {};
      setTimeout(() => {
        that.dialogVisible = true;
      }, 300);
    }
  }
};
</script>

<style lang="less" scoped>



.template-body {
  width: 100%;
  height: 60vh;
  // background-color: rgba(178, 37, 37, 0.3);
  padding: 0 40px 0 20px;
  &-class {
    height: 40px;
    background-color: #fff;
    display: flex;
    justify-content: space-between;
    align-items: center;
    &-l-f {
      display: flex;
      align-items: center;
      width: calc(100% - 285px);
      height: 40px;
      scrollbar-width: none;
      padding: 0 10px 0 0;
      &-span {
        margin: 0 10px 0 0;
        color: #606266;
        cursor: pointer;
        
      }
      &-clicked {
        color: #409eff;
        font-weight: 700;
      }
    }
    &-father {
      min-width: 1500px;
    }
    &-item {
      display: inline-block;
      height: 40px;
    }
  }
  &-main {
    height: calc(100% - 40px);
    width: 100%;
    background-color: #fff;
    // border-top: 1px solid #dcdfe6;
    border-bottom: 1px solid #dcdfe6;
    // padding: 10px 0;
    &-item {
      display: inline-block;
      width: 16vw;
      height: 16vw;
      min-height: 100px;
      background-color: pink;
      margin: 0 10px 10px 0;
    }
  }
  &-main-empty {
    height: calc(100% - 40px);
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 24px;
  }
}
/deep/.el-dialog__header {
  padding: 10px 20px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
/deep/.el-dialog__body {
  padding: 0 !important;
}
/deep/.el-dialog__footer {
  padding: 10px 20px;
}
/deep/ .el-dialog__headerbtn {
  top: 13px;
}

/deep/.el-input-group__append {
  padding: 0 10px !important;
}

/deep/.el-input {
  width: 185px !important;
}

/*滚动条样式*/
/deep/ .scrollbar {
  white-space: nowrap;
  .el-scrollbar {
    display: flex;
    justify-content: space-around;
    padding: 0 10px;
  }
  /deep/ .el-scrollbar__wrap {
    overflow: scroll;
    width: 110%;
    height: 100%;
  }
}
</style>
